import { useEffect, useState } from 'react';

function useDebounce(value, delay) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            // Clearing the timer when the function is called to prevent memory leaks
            clearTimeout(handler);
            setDebounced(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debounced;
}

export default useDebounce;
